import Swal from 'sweetalert2';
import { Color } from '../../assets/colors';
import * as actionTypes from "../action-types";
import { toaster } from '../../services/toast-service';
import { getAPI, postAPI } from '../../utils/api-function';
import { call, put, select, takeLeading } from 'redux-saga/effects';
import { get_customer_address, create_customer_address, delete_customer_address, update_customer_address, get_recharge_history, get_yatra_history, get_product_history, get_puja_history, get_pitr_paksha_history } from '../../utils/api-routes';

//! Address
function* getCustomerAddress() {
    try {
        const customerDetails = yield select(state => state?.authReducer?.customerDetails);

        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield postAPI({ url: get_customer_address, payload: { userId: customerDetails?.userid } });
        console.log("Get Customer Address Saga Response ::: ", data);

        if (data?.success) {
            yield put({ type: actionTypes.SET_CUSTOMER_ADDRESS, payload: data?.results?.reverse() });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        console.log("Get Customer Address Saga Error ::: ", error?.response?.data);
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    }
};

function* createCustomerAddress(action) {
    try {
        const { payload } = action;
        console.log("Create Customer Address Payload ::: ", payload);

        if (!payload?.data?.userId) {
            toaster?.error({ text: 'Please login again to add address.' });
            return;
        }

        const { data } = yield postAPI({ url: create_customer_address, payload: payload?.data });
        console.log("Create Customer Address Saga Response ::: ", data);

        if (data && (data.success || data.userAddress || data.message)) {
            toaster?.success({ text: 'Address added successfully.' });
            yield put({ type: actionTypes?.GET_CUSTOMER_ADDRESS, payload: null });
            yield call(payload?.onComplete);
        } else {
            toaster?.error({ text: data?.message || 'Failed to add address.' });
        }

    } catch (error) {
        const errMsg = error?.response?.data?.message || error?.message || 'Failed to create customer address.';
        toaster?.error({ text: errMsg });
        console.log("Create Customer Address Saga Error ::: ", error?.response?.data);
    }
};

function* updateCustomerAddress(action) {
    try {
        const { payload } = action;
        // console.log("Update Customer Address Payload ::: ", payload);

        const { data } = yield postAPI(update_customer_address, payload?.data);
        console.log("Update Customer Address Saga Response ::: ", data);

        if (data?.success) {
            toaster?.success({ text: 'Address updated successfully.' });
            yield put({ type: actionTypes?.GET_CUSTOMER_ADDRESS, payload: null });
        }

    } catch (error) {
        toaster?.error({ text: 'Failed to update customer address.' });
        console.log("Update Customer Address Saga Error ::: ", error?.response?.data);
    }
};

function* deleteCustomerAddress(action) {
    try {
        const { payload } = action;
        // console.log("Delete Customer Address Payload ::: ", payload);

        const result = yield Swal.fire({ icon: "warning", title: `Are you sure ?`, text: "You want to delete!!!", showCancelButton: true, confirmButtonColor: Color.primary, cancelButtonColor: 'grey', confirmButtonText: "Yes", cancelButtonText: "No" });

        if (result.isConfirmed) {
            const { data } = yield postAPI(delete_customer_address, payload);
            console.log("Delete Customer Address Saga Response ::: ", data);

            if (data?.success) {
                toaster?.success({ text: 'Address deleted successfully.' });
                yield put({ type: actionTypes?.GET_CUSTOMER_ADDRESS, payload: null });
            }
        }

    } catch (error) {
        toaster.error({ text: 'Failed to delete customer address.' });
        console.log("Delete Customer Address Saga Error ::: ", error?.response?.data);
    }
};

//! History
function* getRechargeHistory() {
    try {
        const customerDetails = yield select(state => state?.authReducer?.customerDetails);

        const { data } = yield postAPI({ url: get_recharge_history, payload: { userId: customerDetails?.userid } });
        console.log("Recharge History Saga Response :::", data);

        if (data?.success) {
            yield put({ type: actionTypes.SET_RECHARGE_HISTORY, payload: data?.orderId?.reverse() });
        } else {
            yield put({ type: actionTypes.SET_RECHARGE_HISTORY, payload: [] });
        }
    } catch (error) {
        console.log("Recharge History Saga Error :::", error);
        yield put({ type: actionTypes.SET_RECHARGE_HISTORY, payload: [] });
    }
};

function* getYatraHistory() {
    try {
        const customerDetails = yield select(state => state?.authReducer?.customerDetails);

        const { data } = yield postAPI({ url: get_yatra_history, payload: { customerId: customerDetails?.userid } });
        console.log("Yatra History Saga Response :::", data);

        if (data?.success) {
            yield put({ type: actionTypes.SET_YATRA_HISTORY, payload: data?.history });
        } else {
            yield put({ type: actionTypes.SET_YATRA_HISTORY, payload: [] });
        }
    } catch (error) {
        console.log("Yatra History Saga Error :::", error);
        yield put({ type: actionTypes.SET_YATRA_HISTORY, payload: [] });
    }
};

function* getProductHistory() {
    try {
        const customerDetails = yield select(state => state?.authReducer?.customerDetails);

        const { data } = yield postAPI({ url: get_product_history, payload: { customerId: customerDetails?.userid } });
        console.log("Product History Saga Response :::", data);

        if (data?.success) {
            yield put({ type: actionTypes.SET_PRODUCT_HISTORY, payload: data?.data });
        } else {
            yield put({ type: actionTypes.SET_PRODUCT_HISTORY, payload: [] });
        }
    } catch (error) {
        console.log("Product History Saga Error :::", error);
        yield put({ type: actionTypes.SET_PRODUCT_HISTORY, payload: [] });
    }
};

function* getPujaHistory() {
    try {
        const customerDetails = yield select(state => state?.authReducer?.customerDetails);

        const { data } = yield postAPI({ url: get_puja_history, payload: { customerId: customerDetails?.userid } });
        console.log("Puja History Saga Response :::", data);

        if (data?.success) {
            yield put({ type: actionTypes.SET_PUJA_HISTORY, payload: data?.results });
        } else {
            yield put({ type: actionTypes.SET_PUJA_HISTORY, payload: [] });
        }
    } catch (error) {
        console.log("Puja History Saga Error :::", error);
        yield put({ type: actionTypes.SET_PUJA_HISTORY, payload: [] });
    }
};

function* getPitrPakshaHistory() {
    try {
        const customerDetails = yield select(state => state?.authReducer?.milanSathiCustomerDetails);

        const { data } = yield getAPI({ url: get_pitr_paksha_history(customerDetails?._id) });
        console.log("Puja History Saga Response :::", data);

        if (data?.success) {
            yield put({ type: actionTypes.SET_PITR_PAKSHA_HISTORY, payload: data?.data?.reverse() });
        } else {
            yield put({ type: actionTypes.SET_PITR_PAKSHA_HISTORY, payload: [] });
        }
    } catch (error) {
        console.log("Puja History Saga Error :::", error);
        yield put({ type: actionTypes.SET_PITR_PAKSHA_HISTORY, payload: [] });
    }
};

export default function* customerSaga() {
    //! Address
    yield takeLeading(actionTypes?.GET_CUSTOMER_ADDRESS, getCustomerAddress);
    yield takeLeading(actionTypes?.CREATE_CUSTOMER_ADDRESS, createCustomerAddress);
    yield takeLeading(actionTypes?.UPDATE_CUSTOMER_ADDRESS, updateCustomerAddress);
    yield takeLeading(actionTypes?.DELETE_CUSTOMER_ADDRESS, deleteCustomerAddress);

    //! History
    yield takeLeading(actionTypes.GET_RECHARGE_HISTORY, getRechargeHistory);
    yield takeLeading(actionTypes.GET_YATRA_HISTORY, getYatraHistory);
    yield takeLeading(actionTypes.GET_PRODUCT_HISTORY, getProductHistory);
    yield takeLeading(actionTypes.GET_PUJA_HISTORY, getPujaHistory);
    yield takeLeading(actionTypes.GET_PITR_PAKSHA_HISTORY, getPitrPakshaHistory);
};